'use client';

import { useCallback } from 'react';
import { usePageName } from '../usePageName';
import { RecordRedirect, useAnalytics } from '../useAnalytics';

export type UseExternalRedirectAnalyticsResult = {
    recordRedirect: RecordRedirect;
};

export const useExternalRedirectAnalytics = (): UseExternalRedirectAnalyticsResult => {
    const pageName = usePageName();
    const analytics = useAnalytics();

    const recordRedirect = useCallback<RecordRedirect>(
        async (linkType, href) => {
            if (typeof window === 'undefined') {
                return;
            }

            const url = new URL(window.location.href);
            const source = {
                name: pageName,
                url: url.toString(),
            };

            await analytics.record.externalRedirect(href, source);
        },
        [pageName, analytics]
    );

    return {
        recordRedirect,
    };
};
